import { useEffect, useState } from 'react';

export function useCountdown(targetMs: number): number {
  const [secondsLeft, setSecondsLeft] = useState(() =>
    Math.max(0, Math.ceil((targetMs - Date.now()) / 1000)),
  );

  useEffect(() => {
    let raf = 0;
    const tick = () => {
      const next = Math.max(0, Math.ceil((targetMs - Date.now()) / 1000));
      setSecondsLeft((prev) => (prev === next ? prev : next));
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [targetMs]);

  return secondsLeft;
}

export function formatTimer(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}

// Countdown to a lot's start, coarsening as the start recedes so the medallion
// never shows a misleading sub-minute precision days out:
//   >= 1 day  -> "10d 10h"
//   >= 1 hour -> "23h 59m"
//   < 1 hour  -> "59:59" (hands off to the live MM:SS timer at start)
export function formatStartsIn(seconds: number): string {
  if (seconds >= 86400) {
    const d = Math.floor(seconds / 86400);
    const h = Math.floor((seconds % 86400) / 3600);
    return `${d}d ${h}h`;
  }
  if (seconds >= 3600) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    return `${h}h ${m.toString().padStart(2, '0')}m`;
  }
  return formatTimer(seconds);
}
